
import { Link, Stack, Typography } from "@mui/material";
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PublicIcon from '@mui/icons-material/Public';

export const VChainerFooter = () => {
    return (
        <Stack spacing={2} sx={{ mt: 5 }} alignItems="center">
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
                <Stack direction="row" spacing={1} alignItems="center">
                    <PublicIcon color="primary" fontSize="small" />
                    <Link href="https://v-chainer.com/" underline="hover">
                        v-chainer.com
                    </Link>
                </Stack>

                <Stack direction="row" spacing={1} alignItems="center">
                    <SupportAgentIcon color="primary" fontSize="small" />
                    <Link href="mailto:support@v-chainer.com" underline="hover">
                        support@v-chainer.com
                    </Link>
                </Stack>
            </Stack>

            <Typography variant="caption" color="text.disabled" align="center">
                <strong>V-CHAINER</strong>: Where Validation Meets Virtual Efficiency
            </Typography>
        </Stack>
    );
};
